<template>
    <div style="font-size: 14px;width: 100%">
        <v-layout row class="ma-0">
            <div style="color: rgba(166, 166, 166, 1);width: 60px;line-height: 21px">经纬度</div>
            <div style="color: white;line-height: 21px;width: 170px;margin-left: 17px">
                {{lng.toFixed(4)}},{{lat.toFixed(4)}}
            </div>
        </v-layout>
    </div>
</template>

<script>
    export default {
        name: "LngLatInfo",
        props:["lng","lat"]
    }
</script>

<style scoped>

</style>
